import { setDurationControlValue } from '../shared/duration-control.js';
import { updatePledgePayNowButtonEnabledState } from './pledge-pay-amount';
import { getPayPledge, mergePayPledgeRow, pledgeKey } from './pay-pledge-map';
import { pledgePayBodyFromShell, pledgePayUiRoot } from './pledge-pay-utils';

const STORAGE_KEY = 'deleted-schedule-pay-bill';

function rememberDeletedSchedulePlan(plan) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(plan));
}

function takeDeletedSchedulePlan() {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
        return null;
    }
    sessionStorage.removeItem(STORAGE_KEY);
    try {
        return JSON.parse(raw);
    } catch (e) {
        return null;
    }
}

function stageDeletedSchedulePlan($root, plan) {
    if (!$root || !$root.length || !plan) {
        return;
    }
    $root.data('deletedSchedulePlan', plan);
}

function pledgeKeysForPlan(plan) {
    const keys = [];
    (plan.items || []).forEach((item) => {
        const key = pledgeKey(item.table_name, item.id);
        if (!getPayPledge(key)) {
            return;
        }
        mergePayPledgeRow(item.table_name, item.id, {
            balance_due: Number(item.balance_due) || 0,
        });
        keys.push(key);
    });
    return keys;
}

function writeDeletedScheduleFields($body, plan) {
    const $option = $body.find('select[name="frequency"] option[id="' + plan.frequency_id + '"]');
    if ($option.length) {
        $body.find('select[name="frequency"]').val($option.attr('value'));
    }

    const duration = $body.find('#pledge_payment_duration').get(0);
    if (duration) {
        setDurationControlValue(duration, Number(plan.duration) || 0);
    }

    const $start = $body.find('input[name="pledge_start_date"]');
    if ($start.length && plan.start_date) {
        $start.val(plan.start_date);
        const $datepicker = $start.closest('.pledge-schedule-start-datepicker');
        if ($datepicker.length && $datepicker.data('datepicker')) {
            $datepicker.datepicker('setDate', plan.start_date);
        }
    }

    $body.find('#cover_surcharge').prop('checked', !!plan.cover_surcharge);
    $body.find('input[name="installment_amount"]').val(plan.installment_amount);
    $body.find('input[name="surcharge_installment_amount"]').val(plan.surcharge_amount);
    updatePledgePayNowButtonEnabledState($body);
}

function applyDeletedSchedulePlan($root) {
    const plan = $root && $root.data('deletedSchedulePlan');
    if (!plan) {
        return;
    }
    const $body = pledgePayBodyFromShell(pledgePayUiRoot($root));
    const $recurring = $body.find('#recurring_payment');
    if ($recurring.length && !$recurring.prop('checked')) {
        $recurring.prop('checked', true).trigger('change');
    }
    writeDeletedScheduleFields($body, plan);
    window.setTimeout(function () {
        if ($root.data('deletedSchedulePlan') !== plan) {
            return;
        }
        writeDeletedScheduleFields($body, plan);
    }, 160);
}

function openDeletedSchedulePayBill(plan, openPayBillModal) {
    const keys = pledgeKeysForPlan(plan);
    if (!keys.length) {
        return false;
    }
    const $modal = $('#setPledgePaymentModal');
    stageDeletedSchedulePlan($modal, plan);
    openPayBillModal(keys);
    return true;
}

function openDeletedScheduleFromActivation(response, actions) {
    const plan = response && response.recreate_schedule;
    if (!plan || !Array.isArray(plan.items) || !plan.items.length) {
        return false;
    }
    if (typeof actions.openPayBillModal === 'function') {
        return openDeletedSchedulePayBill(plan, actions.openPayBillModal);
    }
    if (typeof actions.openMemberPayBillPage !== 'function') {
        return false;
    }
    rememberDeletedSchedulePlan(plan);
    actions.openMemberPayBillPage(String(plan.items[0].id));
    return true;
}

function consumeDeletedSchedulePlanForKeys(keys) {
    const plan = takeDeletedSchedulePlan();
    if (!plan || !Array.isArray(plan.items)) {
        return null;
    }
    const opened = new Set((Array.isArray(keys) ? keys : [keys]).map((key) => String(key)));
    const matches = plan.items.some((item) => opened.has(pledgeKey(item.table_name, item.id)));
    if (!matches) {
        rememberDeletedSchedulePlan(plan);
        return null;
    }
    return plan;
}

export {
    applyDeletedSchedulePlan,
    consumeDeletedSchedulePlanForKeys,
    openDeletedScheduleFromActivation,
    pledgeKeysForPlan,
    stageDeletedSchedulePlan,
};
